import { useState } from "react";
import AnnouncementBanner from "@/components/AnnouncementBanner";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import OurStory from "@/components/OurStory";
import WhatWeOffer from "@/components/WhatWeOffer";
import Impact from "@/components/Impact";
import VolunteerForm from "@/components/VolunteerForm";
import ContactSection from "@/components/ContactSection";
import Footer from "@/components/Footer";
import DonationDialog from "@/components/DonationDialog";

export default function Home() {
  const [donateOpen, setDonateOpen] = useState(false);

  const openDonate = () => setDonateOpen(true);
  const scrollToVolunteer = () => {
    const el = document.getElementById("volunteer");
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <div data-testid="home-page" className="min-h-screen bg-[#FDFBF7]">
      <AnnouncementBanner />
      <Header onDonate={openDonate} />
      <main>
        <Hero onDonate={openDonate} onVolunteer={scrollToVolunteer} />
        <OurStory />
        <WhatWeOffer />
        <Impact />
        <VolunteerForm />
        <ContactSection />
      </main>
      <Footer onDonate={openDonate} />
      <DonationDialog open={donateOpen} onOpenChange={setDonateOpen} />
    </div>
  );
}
